var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifier = function SvgMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h802v602H-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "M87.41 85.308L67.055 62.299l.442-.442c5.531-6.195 8.407-14.16 8.186-22.566-1.106-17.257-15.93-30.752-33.185-29.867-17.257.885-30.752 15.708-29.867 32.964.885 16.814 14.823 29.867 31.415 29.867h1.549c5.53-.222 10.62-1.991 15.265-4.867l20.575 23.23 5.973-5.31zM45.152 64.29c-13.052.664-23.893-9.292-24.557-22.345-.663-12.831 9.292-23.893 22.345-24.557h1.106c12.39 0 22.787 9.735 23.451 22.345.221 6.195-1.77 12.168-5.973 16.814-4.204 4.646-9.956 7.522-16.372 7.743z"
  })));
};
export default SvgMagnifier;